import type { FC } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import {
  AppBar,
  Box,
  Divider,
  Hidden,
  IconButton,
  Toolbar
} from '@material-ui/core'
import { experimentalStyled } from '@material-ui/core/styles'
import type { AppBarProps } from '@material-ui/core'
import MenuIcon from '../../icons/Menu'
import AccountPopover from './AccountPopover'
import brandLight from '../../assets/images/brandlight.png'
import brandDark from '../../assets/images/brand.png'

interface DashboardNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void
}

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.background.paper,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none'
  }),
  '& .MuiToolbar-root': {
    paddingLeft: '0.5rem'
  },
  zIndex: theme.zIndex.drawer + 100
}))

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
  const { onSidebarMobileOpen, ...other } = props
  const isDarkTheme =
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <Hidden lgUp>
          <IconButton onClick={onSidebarMobileOpen}>
            <MenuIcon fontSize="small" />
          </IconButton>
        </Hidden>
        <Hidden lgDown>
          <RouterLink to="/">
            <img
              alt="Corvum"
              src={isDarkTheme ? brandLight : brandDark}
              style={{ height: 60 }}
            />
          </RouterLink>
        </Hidden>
        <Box
          sx={{
            flexGrow: 1,
            ml: 2
          }}
        />
        <Box sx={{ ml: 2 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
      <Divider />
    </DashboardNavbarRoot>
  )
}

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
}

export default DashboardNavbar
